import React from 'react';
import { EmptyWrap } from './style';
import emptyIcon from '@/images/empty/none-content.svg';
import nodataIcon from '@/images/empty/none.svg';
import { useTranslation } from 'react-i18next';
interface IEmptyProps {
	type: 'search' | 'nodata';
	tips?: string;
}
const Empty = ({ type, tips }: IEmptyProps) => {
	const { t } = useTranslation();

	return (
		<EmptyWrap>
			<div>
				{type === 'search' && <img src={emptyIcon} alt="" />}
				{type === 'nodata' && <img src={nodataIcon} alt="" />}
				<div className="empty-tip">{tips ? tips : t('common.noSearch')}</div>
			</div>
		</EmptyWrap>
	);
};

export default Empty;
